"use strict";
/**
 * Internal core orchestrator, split from index.ts so scenarios.ts
 * can call it without a circular import.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.runCoreCalculation = void 0;
const accumulation_1 = require("./accumulation");
const withdrawal_1 = require("./withdrawal");
const gap_1 = require("./gap");
function runCoreCalculation(inputs) {
    const accumulation = (0, accumulation_1.projectAccumulation)(inputs);
    const required = (0, withdrawal_1.calculateRequiredCorpus)(inputs);
    const withdrawal = (0, withdrawal_1.projectWithdrawal)(inputs, accumulation.projectedRetirementCorpus);
    const gap = (0, gap_1.solveGap)(inputs, required);
    return { accumulation, required, withdrawal, gap };
}
exports.runCoreCalculation = runCoreCalculation;
